import axios from 'axios';

export const api_service = axios.create({
  baseURL: process.env.REACT_APP_SERVICE_PDF_URL,
});
